'use client';

import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
} from '@eliadmin/core/src/components/ui/select';

import { useCategorySort } from '@eliadmin/core/src/hooks/category/use-category-sort';
import { useTranslations } from '@eliadmin/core/src/hooks/use-translations';
import { cn } from '@eliadmin/core/src/utils/style-utils';

type CategorySortProps = {
  className?: string;
};

export function CategorySortToggle(props: CategorySortProps) {
  const { t } = useTranslations();
  const { selectedValue, onSortChange, VALUES } = useCategorySort();
  const selectedLabel = t(VALUES.find(o => o.value === selectedValue)?.label || '');

  return (
    <Select value={selectedValue} onValueChange={onSortChange}>
      <SelectTrigger
        aria-label={selectedLabel ? `Zoradiť produkty: ${selectedLabel}` : 'Zoradiť produkty'}
        className={cn(
          'col-span-1 h-12 items-center justify-between rounded-none bg-transparent px-6 text-sm font-normal md:max-w-[264px] border-b border-b-border md:text-base lg:h-[52px] uppercase font-heading',
          'ea-category-sort__select-trigger',
        )}
        innerTriggerClassName={cn('w-full p-0 uppercase', 'ea-category-sort__select-trigger-inner')}
      >
        {selectedLabel}
      </SelectTrigger>
      <SelectContent
        className={cn(
          'flex w-[210px] -translate-x-[25px] flex-col items-start justify-start gap-3 rounded-none border border-border bg-white !shadow-none sm:border-t-0 md:w-[300px]',
          'ea-category-sort__select-content',
        )}
      >
        {VALUES.map(o => (
          <SelectItem
            value={o.value}
            key={o.value}
            className={cn(
              'rounded-none px-6 text-sm md:text-base',
              'ea-category-sort__select-item',
            )}
          >
            {t(o.label)}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}

export default CategorySortToggle;
